import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { VehicleYearPage } from './vehicle-year.page';

const routes: Routes = [
  {
    path: '',
    component: VehicleYearPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehicleYearPageRoutingModule {}
